import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { BookOpen } from "lucide-react";
import { ENT_GLOSSARY } from "@/data/entrepreneurshipSim";

export default function EntKeyTermsButton() {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2 text-xs">
          <BookOpen className="w-3.5 h-3.5" /> Key Terms
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-full sm:max-w-md overflow-y-auto">
        <SheetHeader>
          <SheetTitle className="font-heading text-gradient-blue">Entrepreneurship · Key Terms</SheetTitle>
        </SheetHeader>
        <div className="mt-4 space-y-3">
          {ENT_GLOSSARY.map((g) => (
            <div key={g.term} className="rounded-xl border border-border bg-card/60 p-3">
              <p className="font-heading text-sm font-bold text-foreground">{g.term}</p>
              <p className="mt-1 text-xs text-muted-foreground leading-relaxed">{g.def}</p>
            </div>
          ))}
          <p className="text-[10px] text-muted-foreground/70 italic pt-2">
            Simulated business education only. Not investment, legal, or business advice.
          </p>
        </div>
      </SheetContent>
    </Sheet>
  );
}